import React from 'react';
import PropTypes from 'prop-types';

import style from './SubmitButton.module.css';

const PrimaryButton = React.memo(
  ({
    styles = {},
    text,
    type = 'submit',
    onClick = () => true,
    disabled = false,
    'data-testid': testId
  }) => {
    return (
      <input
        className={`btn btn-primary ${style.submitBtn}`}
        type={type}
        value={text}
        style={styles}
        disabled={disabled}
        data-testid={testId}
        onClick={onClick}
      />
    );
  },
);

PrimaryButton.propTypes = {
  styles: PropTypes.shape({}),
  text: PropTypes.string.isRequired,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default PrimaryButton;
